import React, { Component } from "react";
import { Row, Col, FormGroup, FormControl, Checkbox } from "react-bootstrap";

class EngagementStepConfigItem extends Component {
  constructor() {
    super();

    this.state = {
      inputValue: "",
      isChecked: false,
      touched: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.getValidationState = this.getValidationState.bind(this);
    this.checkAndSend = this.checkAndSend.bind(this);
    this.isValid = this.isValid.bind(this);
  }
  componentWillMount() {
    this.setState({
      isChecked: this.props.engagementStep.isChecked,
      inputValue: this.props.engagementStep.label
    });
  }
  handleInputChange(e) {
    let value = e.target.value;
    this.setState(
      {
        inputValue: value,
        touched: true,
        isChecked: true
      },
      () => {
        this.checkAndSend();
      }
    );
  }
  handleCheckboxChange(e) {
    let isChecked = e.target.checked;
    let inputValue = this.state.inputValue;
    if (!isChecked) {
      inputValue = "";
    }
    this.setState(
      {
        inputValue,
        isChecked,
        touched: true
      },
      () => {
        this.checkAndSend();
      }
    );
  }
  checkAndSend() {
    let { inputValue } = this.state;
    const { engagementStep, onUpdate } = this.props;
    let newEngagementStep = {
      name: engagementStep.name,
      label: inputValue,
      isChecked: this.state.isChecked
    };

    onUpdate(newEngagementStep, this.isValid());
  }
  isValid() {
    let { inputValue, isChecked } = this.state;
    let isValid = false;
    if (inputValue !== "" && isChecked) {
      isValid = true;
    }
    return isValid;
  }
  getValidationState() {
    let { touched, isChecked } = this.state;
    if (!touched || !isChecked) {
      return null;
    }
    if (this.isValid()) {
      return "success";
    } else {
      return "error";
    }
  }
  render() {
    const { engagementStep } = this.props;
    return (
      <FormGroup validationState={this.getValidationState()}>
        <Row>
          <Col md={4}>
            <Checkbox
              onChange={this.handleCheckboxChange}
              checked={this.state.isChecked}
            >
              {engagementStep.name}
            </Checkbox>
          </Col>
          <Col md={8}>
            <FormControl
              type="text"
              placeholder="Label"
              onChange={this.handleInputChange}
              value={this.state.inputValue}
            />
          </Col>
        </Row>
      </FormGroup>
    );
  }
}

export default EngagementStepConfigItem;



// WEBPACK FOOTER //
// ./src/components/EngagementStepConfigItem.js